import Line from "../../../../src/entities/Line";
import { EventBus, EnumEventBus } from "./EventBus";
import { Coord } from "../../../../src/types/Interface";
import calcGuideLinePoints from "../helpers/calcGuideLinePoints";


export default class LineManager {
  private EventBus = EventBus;
  private isSuppMode: boolean = false;
  line1 = new Line();
  line2 = new Line();
  line3 = new Line();
  line4 = new Line();
  guideLine1 = new Line({ width: 3 });
  guideLine2 = new Line({ width: 3 });

  constructor() {
    this.EventBus.on(EnumEventBus.supplementaryMode, (v: boolean) => this.isSuppMode = v);
  }

  draw([p1, p2, p3, p4]: Coord[]) {
    this.drawLines([p1, p2, p3, p4]);
    this.isSuppMode && this.drawGuideLines([p1, p2, p3, p4])
  }
  drawLines([p1, p2, p3, p4]: Coord[]) {
    this.line1.draw(p1, p2);
    this.line2.draw(p2, p3);
    this.line3.draw(p3, p4);
    this.line4.draw(p4, p1);
  }
  drawGuideLines([p1, p2, p3, p4]: Coord[]) {
    const gl1 = calcGuideLinePoints(p2, p3, 120);
    const gl2 = calcGuideLinePoints(p3, p2, 120);
    this.guideLine1.draw(gl1[0], gl1[1]);
    this.guideLine2.draw(gl2[0], gl2[1]);
  }
  getGuideLinesCoords([p1, p2, p3, p4]: Coord[]) {
    return [calcGuideLinePoints(p2, p3, 120), calcGuideLinePoints(p3, p2, 120)]
  }
}